module.exports = __webpack_public_path__ + "img/team-business.3b46ccc6.svg";